import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import {connect} from 'react-redux';

import EllipsisMenu   from 'app/components/common/ellipsis-menu';
import Icon           from 'app/components/common/icon';
import NumberInput    from 'app/components/common/number-input';
import SortableList   from 'app/components/common/sortable-list';
import StandardInput  from 'app/components/common/standard-input';
import StandardSelect from 'app/components/common/standard-select';
import CritOpts       from 'app/components/company-admin/grant-system/rubric/crit-opts';
import RubricForm     from 'app/components/company-admin/grant-system/rubric/form';
import RubBldrDuck    from 'app/ducks/company-admin/rubric-builder';
import helpers        from 'app/helpers/rubrics';

const {
  ScalePresetTypes,
  formatWeight,
  normTypeOpts,
  gradLabelPresetOpts,
  GradLabelPresetTypes,
  NormTypes,
} = helpers;



class OptInputRaw extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChangeLabel = this.onChangeLabel.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onChangeStyle = this.onChangeStyle.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onInputKeyPress = this.onInputKeyPress.bind(this);
  }
  onChangeLabel(event, label) {
    this.props.updateOpt({label});
  }
  onChangeValue(value) {
    this.props.updateOpt({value});
  }
  onChangeStyle(style) {
    this.props.updateOpt({style});
  }
  onClickDelete() {
    this.props.deleteOpt();
  }
  onInputKeyPress(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) {
      this.props.onDone();
    }
  }
  render() {
    const {opt, showValidations} = this.props;
    if (!opt) return null;
    const validations = (showValidations && opt.validations) || null;
    return (
      <div className="rub-inp-crit-opt-inp">
        <StandardInput  name="label" label="Label"  onChange={this.onChangeLabel} elevateFocus value={opt.label || ''} className="small" validations={validations} onKeyPress={this.onInputKeyPress} />
        <NumberInput    name="value" label="Points" onChange={this.onChangeValue} elevateFocus value={opt.value || 0} className="small" icon={null} min={0} allowNull={false} validations={validations} onKeyPress={this.onInputKeyPress} />
        <StandardSelect name="style" label="Style"  onSelect={this.onChangeStyle} elevateFocus value={opt.style} small options={helpers.optionOpts} validations={validations} />
        <EllipsisMenu className="alt1">
          <button onClick={this.onClickDelete}><Icon.Bin />Remove Option</button>
        </EllipsisMenu>
      </div>
    );
  }
}
const optStateToProps = (state, ownProps) => ({
  opt: RubBldrDuck.Slx.opt(state, ownProps.optId),
});
const optDispatchToProps = (dispatch, ownProps) => ({
  updateOpt: (attrs) => dispatch(RubBldrDuck.Ax.updateOpt(ownProps.optId, attrs)),
  deleteOpt: () => dispatch(RubBldrDuck.Ax.deleteOpt(ownProps.critId, ownProps.optId)),
});
const OptInput = connect(optStateToProps, optDispatchToProps)(OptInputRaw);
OptInput.propTypes = {
  critId: PropTypes.string.isRequired,
  optId: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
};



class GradLblInputRaw extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChangeLabel = this.onChangeLabel.bind(this);
    this.onChangeThreshold = this.onChangeThreshold.bind(this);
    this.onChangeStyle = this.onChangeStyle.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onInputKeyPress = this.onInputKeyPress.bind(this);
  }
  onChangeLabel(event, label) {
    this.props.updateGradLbl({label});
  }
  onChangeThreshold(floatVal) {
    const threshold = (floatVal == null) ? 0 : Math.round(floatVal * 1000);
    this.props.updateGradLbl({threshold});
  }
  onChangeStyle(style) {
    this.props.updateGradLbl({style});
  }
  onClickDelete() {
    this.props.deleteGradLbl();
  }
  onInputKeyPress(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) {
      this.props.onDone();
    }
  }
  render() {
    const {gradLbl, showValidations, lowestThreshold} = this.props;
    if (!gradLbl) return null;
    const validations = (showValidations && gradLbl.validations) || null;
    const thresholdVal = (gradLbl.threshold || 0) / 1000;
    const isDefault = thresholdVal === 0;
    return (
      <div className="rub-inp-gradlbl">
        <div className="rub-inp-gradlbl-inps">
          <div className="rub-inp-gradlbl-inp">
            {isDefault
              ? <StandardInput  name="threshold" label="Min %" value={`Below ${formatWeight(lowestThreshold)}`} className="small" icon={null} disabled />
              : <NumberInput    name="threshold" label="Min %" onChange={this.onChangeThreshold} elevateFocus value={thresholdVal} className="small" icon={null} min={1} max={100} decPlaces={3} allowNull={false} validations={validations} onKeyPress={this.onInputKeyPress} disabled={isDefault} />
            }
          </div>
          <div className="rub-inp-gradlbl-inp">
            <StandardInput  name="label"     label="Label" onChange={this.onChangeLabel}     elevateFocus value={gradLbl.label || ''} className="small" validations={validations} onKeyPress={this.onInputKeyPress} />
          </div>
          <div className="rub-inp-gradlbl-inp">
            <StandardSelect name="style"     label="Style" onSelect={this.onChangeStyle}     elevateFocus value={gradLbl.style} small options={helpers.optionOpts} validations={validations} />
          </div>
        </div>
        <div className="rub-inp-gradlbl-menu">
          {!isDefault && (
            <EllipsisMenu className="alt1">
              <button onClick={this.onClickDelete}><Icon.Bin />Remove Label</button>
            </EllipsisMenu>
          )}
        </div>
      </div>
    );
  }
}
const gradLblStateToProps = (state, ownProps) => {
  return {
    gradLbl: RubBldrDuck.Slx.gradLbl(state, ownProps.gradLblId),
    lowestThreshold: RubBldrDuck.Slx.rubLowestGradLblVal(state, ownProps.rubId),
    showValidations: RubBldrDuck.Slx.rub(state, ownProps.rubId).showGradLblValidations,
  };
};
const gradLblDispatchToProps = (dispatch, ownProps) => ({
  updateGradLbl: (attrs) => dispatch(RubBldrDuck.Ax.updateGradLbl(ownProps.gradLblId, attrs)),
  deleteGradLbl: () => dispatch(RubBldrDuck.Ax.deleteGradLbl(ownProps.rubId, ownProps.gradLblId)),
});
const GradLblInput = connect(gradLblStateToProps, gradLblDispatchToProps)(GradLblInputRaw);
GradLblInput.propTypes = {
  rubId: PropTypes.string.isRequired,
  gradLblId: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
};



class CritInputRaw extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClickDispCell = this.onClickDispCell.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickEditDone = this.onClickEditDone.bind(this);
    this.onClickEditRange = this.onClickEditRange.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickDuplicate = this.onClickDuplicate.bind(this);
    this.onClickAddOpt = this.onClickAddOpt.bind(this);
    this.onChangeLabel = this.onChangeLabel.bind(this);
    this.onChangeWeight = this.onChangeWeight.bind(this);
    this.onChangeScalePreset = this.onChangeScalePreset.bind(this);
    this.onKeyPressMainAttr = this.onKeyPressMainAttr.bind(this);
    this.onKeyPressRange = this.onKeyPressRange.bind(this);
    this.onChangeRangeMin = this.onChangeRangeMin.bind(this);
    this.onChangeRangeMax = this.onChangeRangeMax.bind(this);
    this.onDoneOptInput = this.onDoneOptInput.bind(this);
  }
  get isRange() {
    return !!this.props.crit.range;
  }
  onClickEdit() {
    // this.setState({editScale: true});
    this.props.startEdit();
  }
  onClickEditDone() {
    this.props.finishEdit();
  }
  onClickEditRange(event) {
    const attrEl = event.target?.closest('.rub-inp-crit-opts-range-attr');
    this.props.startEdit();
    if (!attrEl) return;
    setTimeout(() => {
      const inputEl = attrEl.querySelector('input');
      if (inputEl) inputEl.focus();
    }, 0);
  }
  onKeyPressRange(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) this.onClickEditDone();
  }
  onChangeRangeMin(min) {
    const range = {min, max: this.props.crit.range.max};
    this.props.updateCrit({range});
  }
  onChangeRangeMax(max) {
    const range = {min: this.props.crit.range.min, max};
    this.props.updateCrit({range});
  }
  onClickDispCell(event) {
    const cellEl = event.target.closest('.rub-inp-crit-cell');
    this.props.startEdit();
    if (!cellEl) return;
    setTimeout(() => {
      const inputEl = cellEl.querySelector('input');
      const btnEl = cellEl.querySelector('.dd-button');
      inputEl?.focus();
      btnEl?.click();
    }, 0);
  }
  onChangeLabel(event, label) {
    this.props.updateCrit({label});
  }
  onChangeWeight(floatWeight) {
    const weight = (floatWeight == null) ? 0 : Math.round(floatWeight * 1000);
    this.props.updateCrit({weight});
  }
  onChangeScalePreset(presetKey) {
    if (this.props.crit.presetKey === presetKey) {
      this.props.finishEdit();
      return;
    }
    this.props.adoptScalePreset(presetKey);
    const isCustom = [ScalePresetTypes.OPTS_CUSTOM, ScalePresetTypes.RNG_CUSTOM].includes(presetKey);
    if (!isCustom) this.props.finishEdit();
  }
  onKeyPressMainAttr(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) this.onClickEditDone();
  }
  onClickDuplicate() {
    this.props.duplicateCrit();
  }
  onClickDelete() {
    this.props.deleteCrit();
  }
  onClickAddOpt() {
    this.props.addOpt();
  }
  onDoneOptInput() {
    this.onClickEditDone();
  }
  render() {
    const {crit, hasMany} = this.props;
    if (!crit) return null;
    const showValidations = this.props.showValidations || crit.showValidations;
    const validations = (showValidations && crit.validations) || null;
    const isEdit = !!(this.props.isEdit || validations);
    const scale = helpers.scalePresets[crit.presetKey];
    const {dndHandleEl} = this.props;
    const weightPercent = (crit.weight || 0) / 1000;
    const weightFmt = numeral(weightPercent / 100).format('0[.][000]%');
    const scaleLabel = (() => {
      if (scale?.title) return scale.title;
      if (crit.presetKey === ScalePresetTypes.OPTS_CUSTOM) return 'Custom Options';
      if (crit.presetKey === ScalePresetTypes.RNG_CUSTOM) return 'Custom Range';
      return 'Custom';
    })();
    const scaleVMsg = validations?.scale || null;
    return (
      <div className={`rub-inp-crit ${isEdit ? 'edit' : 'disp'}`}>
        <div className={`rub-inp-crit-main`}>
          <div className="rub-inp-crit-dnd-handle-con">{hasMany && dndHandleEl}</div>
          <div className={`rub-inp-crit-cells`}>
            <div className={`rub-inp-crit-cell label`}>
              {isEdit
                ? <StandardInput name="label" label="Title" value={crit.label} onChange={this.onChangeLabel} onKeyPress={this.onKeyPressMainAttr} className="small" validations={validations} />
                : <div className="rub-inp-crit-cell-disp" onClick={this.onClickDispCell}>{crit.label}</div>
              }
            </div>
            {hasMany && (
              <div className={`rub-inp-crit-cell weight`}>
                {isEdit
                  ? <NumberInput name="weight" label="% Weight" value={weightPercent} onChange={this.onChangeWeight} onKeyPress={this.onKeyPressMainAttr} className="small" min={0} max={100} decPlaces={3} icon={null} validations={validations} />
                  : <div className="rub-inp-crit-cell-disp" onClick={this.onClickDispCell}>{weightFmt}</div>
                }
              </div>
            )}
            <div className={`rub-inp-crit-cell scale`}>
              {isEdit
                ? <StandardSelect className="small" options={helpers.scalePresetOpts} onSelect={this.onChangeScalePreset} value={crit.presetKey} />
                : <div className="rub-inp-crit-cell-disp" onClick={this.onClickDispCell}>{scaleLabel}<Icon.Caret direction="down" className="rub-inp-crit-cell-disp-caret" /></div>
              }
            </div>
          </div>
          <div className={`rub-inp-crit-actions`}>
            {isEdit ? (<>
              <button className="btn small blue" onClick={this.onClickEditDone}>Done</button>
            </>) : (<>
              <EllipsisMenu usePortal className="alt1">
                <button onClick={this.onClickEdit}><Icon.Pencil />Edit</button>
                <button onClick={this.onClickDuplicate}><Icon.AddCircle1 />Duplicate</button>
                <button onClick={this.onClickDelete}><Icon.Bin />Delete</button>
              </EllipsisMenu>
            </>)}
          </div>
        </div>
        {this.isRange && (
          <div className={`rub-inp-crit-opts ${isEdit ? 'edit' : 'disp'}`}>
            <div className="rub-inp-crit-opts-range">
              <div className="rub-inp-crit-opts-range-attr">
                <label className="rub-inp-crit-opts-range-attr-lbl">Min</label>
                {isEdit
                  ? <NumberInput onChange={this.onChangeRangeMin} value={crit.range.min || 0} className="rub-inp-crit-opts-range-attr-input small" min={0} allowNull={false} icon={null} onKeyPress={this.onKeyPressRange} name="rangeMin" validations={validations} />
                  : <div className="rub-inp-crit-opts-range-attr-disp" onClick={this.onClickEditRange}>{crit.range.min}</div>
                }
              </div>
              <div className="rub-inp-crit-opts-range-attr">
                <label className="rub-inp-crit-opts-range-attr-lbl">Max</label>
                {isEdit
                  ? <NumberInput onChange={this.onChangeRangeMax} value={crit.range.max || 0} className="rub-inp-crit-opts-range-attr-input small" min={1} allowNull={false} icon={null} onKeyPress={this.onKeyPressRange} name="rangeMax" validations={validations} />
                  : <div className="rub-inp-crit-opts-range-attr-disp" onClick={this.onClickEditRange}>{crit.range.max}</div>
                }
              </div>
            </div>
            {scaleVMsg && <p className="_clr-danger _fs-11 _upper _fw-bold _m-0 _mt-12">{scaleVMsg}</p>}
          </div>
        )}
        {!this.isRange && (
          <div className={`rub-inp-crit-opts ${isEdit ? 'edit' : 'disp'}`}>
            {isEdit ? (<>
              <div className="rub-inp-crit-opts-list" key="list">
                <div className="rub-inp-crit-opts-list-header">
                  <div className="rub-inp-crit-opts-list-header-cell">Label</div>
                  <div className="rub-inp-crit-opts-list-header-cell">Points</div>
                  <div className="rub-inp-crit-opts-list-header-cell">Style</div>
                </div>
                {crit.opts.map((opt, oi) => {
                  return <OptInput optId={opt.id} key={oi} critId={crit.id} showValidations={showValidations} onDone={this.onDoneOptInput} />
                })}
              </div>
              <div className="rub-inp-crit-opts-actions">
                <button className="btn xs secondary ghost blue icon" onClick={this.onClickAddOpt}><Icon.Add sw2 />Add Option</button>
              </div>
              {scaleVMsg && <p className="_clr-danger _fs-11 _upper _fw-bold _m-0 _mt-12">{scaleVMsg}</p>}
            </>) : (<>
              <div onClick={this.onClickEdit}>
                <CritOpts options={crit.opts} size="xs" showVals staticTags />
              </div>
            </>)}
          </div>
        )}
      </div>
    );
  }
}
const critStateToProps = (state, ownProps) => {
  const rub = RubBldrDuck.Slx.rub(state, ownProps.rubId);
  return {
    crit: RubBldrDuck.Slx.crit(state, ownProps.critId),
    hasMany: rub.critIds?.length > 1,
    isEdit: rub.editCritId === ownProps.critId,
    showValidations: !!rub.showValidations,
  };
};
const critDispatchToProps = (dispatch, ownProps) => ({
  updateCrit: (attrs) => dispatch(RubBldrDuck.Ax.updateCrit(ownProps.critId, attrs)),
  deleteCrit: () => dispatch(RubBldrDuck.Ax.deleteCrit(ownProps.rubId, ownProps.critId)),
  duplicateCrit: () => dispatch(RubBldrDuck.Ax.duplicateCrit(ownProps.rubId, ownProps.critId)),
  adoptScalePreset: (preset) => dispatch(RubBldrDuck.Ax.adoptScalePreset(ownProps.critId, preset)),
  addOpt: () => dispatch(RubBldrDuck.Ax.addOpt(ownProps.critId)),
  sortOpts: () => dispatch(RubBldrDuck.Ax.sortOpts(ownProps.critId)),
  startEdit: () => dispatch(RubBldrDuck.Ax.editCrit(ownProps.rubId, ownProps.critId)),
  finishEdit: () => dispatch(RubBldrDuck.Ax.editCrit(ownProps.rubId, null)),
});
const CritInput = connect(critStateToProps, critDispatchToProps)(CritInputRaw);
CritInput.propTypes = {
  critId: PropTypes.string.isRequired,
  rubId: PropTypes.string.isRequired,
  dndHandleEl: PropTypes.node.isRequired,
};




class RubricInputRaw extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'edit', // or 'preview'
    };
    this.renderCrit = this.renderCrit.bind(this);
    this.onClickAddCrit = this.onClickAddCrit.bind(this);
    this.onSortCrits = this.onSortCrits.bind(this);
    this.onClickModeEdit = this.onClickModeEdit.bind(this);
    this.onClickModePreview = this.onClickModePreview.bind(this);
    this.onClickRescaleWeights = this.onClickRescaleWeights.bind(this);
    this.onClickEqualizeWeights = this.onClickEqualizeWeights.bind(this);
    this.onSelectNormType = this.onSelectNormType.bind(this);
    this.onSelectGradLabelPreset = this.onSelectGradLabelPreset.bind(this);
    this.onClickAddGradLbl = this.onClickAddGradLbl.bind(this);
    this.onClickEditGradLbls = this.onClickEditGradLbls.bind(this);
    this.onClickEditGradLblsDone = this.onClickEditGradLblsDone.bind(this);
    this.onDoneGradLbl = this.onDoneGradLbl.bind(this);
  }
  componentDidMount() {
    this.props.loadRub();
  }
  componentWillUnmount() {
    this.props.unloadRub();
  }
  componentDidUpdate(prevProps) {
    const {saveAttrs, rubric, onChange} = this.props;
    if (!onChange) return;
    const isValid = !rubric?.validations;
    const wasValid = !prevProps.rubric?.validations;
    const didChange = (saveAttrs !== prevProps.saveAttrs) || (isValid !== wasValid);
    const isDone = !rubric.editCritId && !rubric.editGradLbls;
    if (didChange) onChange(isValid, isDone, saveAttrs);
  }
  onClickModeEdit() {
    this.setState({mode: 'edit'});
  }
  onClickModePreview() {
    this.setState({mode: 'preview'});
  }
  onClickAddCrit() {
    this.props.addCrit();
  }
  onSortCrits(critIds) {
    this.props.updateRub({critIds});
  }
  onClickRescaleWeights() {
    this.props.rescaleWeights();
  }
  onClickEqualizeWeights() {
    this.props.equalizeWeights();
  }
  onSelectNormType(normType) {
    if (this.props.rubric.normType === normType) return;
    this.props.setNormType(normType);
  }
  onSelectGradLabelPreset(presetKey) {
    if (this.props.rubric.gradLabelPresetKey === presetKey) return;
    this.props.adoptGradLabelPreset(presetKey);
  }
  onClickAddGradLbl() {
    this.props.addGradLbl();
  }
  onClickEditGradLbls() {
    this.props.startEditGradLbls();
  }
  onClickEditGradLblsDone() {
    this.props.finishEditGradLbls();
  }
  onDoneGradLbl() {
    this.onClickEditGradLblsDone();
  }
  renderPreview() {
    const {rubric, saveAttrs} = this.props;
    return (
      <div className="rub-prvw _p-48">
        <RubricForm rubric={saveAttrs} />
      </div>
    );
  }
  renderCrit(critId, index, dnd) {
    return (
      <div className={`rub-inp-crit-con ${dnd.className}`}>
        <CritInput rubId={this.props.rubric.id} critId={critId} dndHandleEl={dnd.handleEl} />
      </div>
    );
  }
  renderSectionWeights() {
    const {rubric} = this.props;
    const total = rubric.crits.reduce((acc, crit) => { return acc + crit.weight; }, 0);
    const is100   = total === 100_000;
    if (rubric.crits.length === 0) return null;
    if (rubric.crits.length === 1 && is100) return null;
    const isOver  = total >   100_000;
    const isUnder = total <   100_000;
    const isEven = helpers.areWeightsEqual(rubric.crits);
    const diff = Math.abs(total - 100_000);
    const id = `cb-keep-equal-${rubric.id}`;
    const msg = (() => {
      if (isOver)  return `${formatWeight(total)} assigned, ${formatWeight(diff)} over`;
      if (isUnder) return `${formatWeight(total)} assigned, ${formatWeight(diff)} left`;
      return 'Weights add up to 100%';
    })();

    return (
      <div className="rub-inp-section">
        <div className="rub-inp-section-header">
          <div className="rub-inp-section-header-title">Weights</div>
          <div className={`rub-inp-section-header-subtitle ${is100 ? '_clr-green-d10' : '_clr-danger'}`}>
            <div className={`rub-inp-weights-dot ${is100 ? 'green' : 'red'}`} />
            {msg}
          </div>
          <div className="rub-inp-section-header-actions">
            {!is100  && <button className="btn xs secondary ghost blue" onClick={this.onClickRescaleWeights}>Rescale to 100%</button>}
            {!isEven && <button className="btn xs secondary ghost blue" onClick={this.onClickEqualizeWeights}>Split Evenly</button>}
          </div>
        </div>
        <div className="rub-inp-section-body">
          <div className="rub-inp-weights-bar">
            {rubric.crits.map((crit, i) => {
              return (
                <div key={i} className="rub-inp-weights-bar-segment" style={{width: `${crit.weight / 1000}%`}}>{`${formatWeight(crit.weight)} ${crit.label}`}</div>
              );
            })}
            {isUnder && (
              <div className="rub-inp-weights-bar-segment unassigned" style={{width: `${diff / 1000}%`}}>Unassigned</div>
            )}
          </div>
        </div>
      </div>
    );
  }
  renderSectionCrits() {
    const {rubric} = this.props;
    const hasMany = rubric.critIds?.length > 1;
    const hasInvalidCrit = !!(rubric.crits || []).find(c => c.validations);
    return (
      <div className="rub-inp-section">
        <div className="rub-inp-section-header">
          <div className="rub-inp-section-header-title">Criteria</div>
          <div className="rub-inp-section-header-actions">
            <button className="btn xs secondary ghost blue icon" onClick={this.onClickAddCrit} disabled={hasInvalidCrit}><Icon.Add />Add Criterion</button>
          </div>
        </div>
        <div className="rub-inp-section-body">
          <div className="rub-inp-crits-header _upper _fs-12 _fw-bold _clr-mid">
            <div className="rub-inp-crits-header-cell">Label</div>
            {hasMany && (
              <div className="rub-inp-crits-header-cell">Weight</div>
            )}
            <div className="rub-inp-crits-header-cell">Scale</div>
            <div className="rub-inp-crits-header-cell">&nbsp;</div>
          </div>
          <div className="rub-inp-crits">
            <SortableList items={rubric.critIds} renderItem={this.renderCrit} onSort={this.onSortCrits} distinctHandle />
          </div>
        </div>
      </div>
    );
  }
  renderSectionNorm() {
    const {rubric, lowestGradLblThreshold} = this.props;
    if (rubric.crits.length < 2) return null;
    const labelsAsOpts = (rubric.gradLbls || []).map((gl) => {
      const isDefault = gl.threshold === 0;
      return {
        label: gl.label,
        style: gl.style,
        value: isDefault ? `< ${formatWeight(lowestGradLblThreshold)}` : `>= ${formatWeight(gl.threshold)}`,
      };
    }).reverse();
    const isLabels = rubric.normType === NormTypes.GRAD_LABELS;
    const uniqMsg = rubric.validations?.gradLblThresholds?.[0] || null;
    const isEdit = !!(rubric.editGradLbls || (uniqMsg && rubric.showValidations));
    return (
      <div className="rub-inp-section _bg-ice">
        <div className="rub-inp-section-header">
          <div className="rub-inp-section-header-title">Score Display</div>
        </div>
        <div className="rub-inp-section-body">
          <div className="rub-inp-norm-main">
            <div className="rub-inp-norm-main-attr">
              <div className="rub-inp-norm-main-attr-lbl">Normalize As</div>
              <StandardSelect className="rub-inp-norm-main-attr-input" small options={normTypeOpts} onSelect={this.onSelectNormType} value={rubric.normType} />
            </div>
            {isLabels && (<>
              <div className="rub-inp-norm-main-attr">
                <div className="rub-inp-norm-main-attr-lbl">Preset</div>
                <StandardSelect className="rub-inp-norm-main-attr-input" small options={gradLabelPresetOpts} onSelect={this.onSelectGradLabelPreset} value={rubric.gradLabelPresetKey || GradLabelPresetTypes.CUSTOM} />
              </div>
              <div className="rub-inp-norm-main-spacer" />
              {isEdit
                ? <button className="btn blue small" onClick={this.onClickEditGradLblsDone}>Done</button>
                : <button className="btn blue xs secondary ghost" onClick={this.onClickEditGradLbls}>Edit Labels</button>
              }
            </>)}
          </div>
          {isLabels && (
            <div className="_mt-24">
              {isEdit ? (<>
                <div className="rub-inp-norm-labels-list _mb-12">
                  <div className="rub-inp-norm-labels-header">
                    <div className="rub-inp-norm-labels-header-cell">Min Score %</div>
                    <div className="rub-inp-norm-labels-header-cell">Label</div>
                    <div className="rub-inp-norm-labels-header-cell">Style</div>
                  </div>
                  {(rubric.gradLblIds || []).map((gradLblId) => {
                    return <GradLblInput key={gradLblId} gradLblId={gradLblId} rubId={rubric.id} onDone={this.onDoneGradLbl} />
                  })}
                </div>
                <button className="btn xs secondary ghost icon blue" onClick={this.onClickAddGradLbl}><Icon.Add />Add Label</button>
              </>) : (<>
                <div onClick={this.onClickEditGradLbls}>
                  <CritOpts options={labelsAsOpts} size="xs" showVals staticTags />
                </div>
              </>)}
              {uniqMsg && <p className="_fs-11 _clr-danger _upper _fw-bold">{uniqMsg}</p>}
            </div>
          )}
        </div>
      </div>
    );
  }
  render() {
    const {rubric} = this.props;
    if (!rubric) return null;
    const isEdit = this.state.mode === 'edit';
    const has0 = !rubric.critIds?.length;

    if (has0) return (
      <div className="rub-inp _p-24 _flex _align-center _justify-between _gap-24">
        <p className="_m-0 _italic">No scoring criteria configured.</p>
        <button className="btn xs blue icon secondary ghost" onClick={this.onClickAddCrit}><Icon.Add />Add Scoring Criterion</button>
      </div>
    );

    return (
      <div className="rub-inp">
        <div className="rub-inp-top _flex _justify-between _pr-12">
          <div className="rub-inp-top-tabs _flex _gap-0 _align-stretch _justify-start">
            <button className={`rub-inp-top-tabs-tab ${isEdit ? 'active' : ''}`} onClick={this.onClickModeEdit}>Edit</button>
            <button className={`rub-inp-top-tabs-tab ${isEdit ? '' : 'active'}`} disabled={!!rubric.validations} onClick={this.onClickModePreview}>Preview</button>
          </div>
          {false && (
            <EllipsisMenu usePortal className="alt1">
              <button onClick={this.onClickAddCrit}><Icon.Add sw2 /> Add Criterion</button>
            </EllipsisMenu>
          )}
        </div>
        {isEdit ? (<>
          {this.renderSectionCrits()}
          {this.renderSectionWeights()}
          {this.renderSectionNorm()}
        </>) : (<>
          {this.renderPreview()}
        </>)}
      </div>
    );
  }
}
const rubStateToProps = (state, ownProps) => ({
  rawRubric: ownProps.rubric,
  lowestGradLblThreshold: RubBldrDuck.Slx.rubLowestGradLblVal(state, ownProps.rubric.id),
  rubric: RubBldrDuck.Slx.rub(state, ownProps.rubric.id),
  saveAttrs: RubBldrDuck.Slx.saveAttrs(state, ownProps.rubric.id),
});
const rubDispatchToProps = (dispatch, ownProps) => ({
  loadRub: () => dispatch(RubBldrDuck.Ax.setRub(ownProps.rubric)),
  unloadRub: () => dispatch(RubBldrDuck.Ax.unloadRub(ownProps.rubric.id)),
  updateRub: (attrs) => dispatch(RubBldrDuck.Ax.updateRub(ownProps.rubric.id, attrs)),
  equalizeWeights: () => dispatch(RubBldrDuck.Ax.equalizeWeights(ownProps.rubric.id)),
  rescaleWeights: () => dispatch(RubBldrDuck.Ax.rescaleWeights(ownProps.rubric.id)),
  addCrit: () => dispatch(RubBldrDuck.Ax.addCrit(ownProps.rubric.id)),
  editCrit: (critId) => dispatch(RubBldrDuck.Ax.editCrit(ownProps.rubric.id, critId)),

  setNormType: (normType) => dispatch(RubBldrDuck.Ax.setNormType(ownProps.rubric.id, normType)),
  addGradLbl: () => dispatch(RubBldrDuck.Ax.addGradLbl(ownProps.rubric.id)),
  deleteGradLbl: (gradLblId) => dispatch(RubBldrDuck.Ax.deleteGradLbl(ownProps.rubric.id, gradLblId)),
  adoptGradLabelPreset: (presetKey) => dispatch(RubBldrDuck.Ax.adoptGradLabelPreset(ownProps.rubric.id, presetKey)),
  startEditGradLbls: () => dispatch(RubBldrDuck.Ax.setEditGradLbls(ownProps.rubric.id, true)),
  finishEditGradLbls: () => dispatch(RubBldrDuck.Ax.setEditGradLbls(ownProps.rubric.id, false)),
});
const RubricInput = connect(rubStateToProps, rubDispatchToProps)(RubricInputRaw);
RubricInput.propTypes = {
  rubric: PropTypes.object,
  onChange: PropTypes.func, // (isValid, saveAttrs) => void
};

export default RubricInput;
